import { ref } from "@vue/composition-api";

export const mqShallShowSidebarLeft = ref(false);
export const mobilePluginBarActive = ref(false);

export default function useUx() {
    return {};
}
